import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/header';
import './index.css';

export default function Constituicoes() {
  const navigate = useNavigate();
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [nextText, setNextText] = useState('');

  const handleTransition = (route, text) => {
    setNextText(text);
    setIsTransitioning(true);
    setTimeout(() => {
      navigate(route);
    }, 1000);
  };

  // Lista de constituições (ano visível e rota interna)
  const constituicoes = [
    { ano: '1824', path: '/constituicoes/1824' },
    { ano: '1890', path: '/constituicoes/1890' },
    { ano: '1934', path: '/constituicoes/1934' },
    { ano: '1937', path: '/constituicoes/1937' },
    { ano: '1946', path: '/constituicoes/1946' },
    { ano: '1967', path: '/constituicoes/1967' },
    { ano: '1988', path: '/constituicoes/1988' },
  ];

  return (
    <div>
      <Header show={false} cor="branco" />
      <div id="constituicoes-capa">
        <div id="constituicoes-overlay">
          <div id="constituicoes-titulo">
            <p>CONSTITUIÇÕES BRASILEIRAS</p>
            <div className="anos">
              {constituicoes.map((item) => (
                <div key={item.ano}>
                  <div className="const-div" />
                  <span
                    className="constit-link"
                    onClick={() => handleTransition(item.path, `Constituição de ${item.ano}`)}
                    style={{ cursor: 'pointer', color: 'white', textDecoration: 'underline' }}
                  >
                    {item.ano}
                  </span>
                </div>
              ))}
            </div>

            <div className="texto">
              A Constituição contempla, já em seu preâmbulo, inovação relevante, quando os Constituintes declaram como objetivo da Assembleia instituir um Estado de Direito Democrático e é feita referência à sociedade fraterna, pluralista e sem preconceitos que se quer afirmar.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
